export const LOAD_CUSTOMER_USERS = "LOAD_CUSTOMER_USERS",
  LOAD_CUSTOMER_USERS_SUCCESS = "LOAD_CUSTOMER_USERS_SUCCESS",
  LOAD_CUSTOMER_USERS_ERROR = "LOAD_CUSTOMER_USERS_ERROR",
  LOAD_NEW_USER_PAGE = "LOAD_NEW_USER_PAGE";
